import { render, staticRenderFns } from "./CategoryTreeConfig.vue?vue&type=template&id=47f4b29f"
import script from "./CategoryTreeConfig.vue?vue&type=script&lang=js"
export * from "./CategoryTreeConfig.vue?vue&type=script&lang=js"
import style0 from "./CategoryTreeConfig.vue?vue&type=style&index=0&id=47f4b29f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports